import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Box Timing chart',
  description: 'Displays average timing'
};



// WEBPACK FOOTER //
// ./app/widgets/BoxTimingChart/index.js